import { Button, H3, P } from '@ahmdigital/ui';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { Article } from '../../../../../types/__codegen__/sanity/graphql';
import { ArticleTileWrapper, HeadingWrapper, StyledImage } from './styles';
import { TRIM_CHARACTER_LIMIT } from '../../../../../pages/pages-hub/constants';
import ArticleMetadata from '../../../../../pages/blog-detail/components/article-metadata';
import constants from '../../../../../ahm-constants';
import createLimitedBlurb from '../../../../../pages/pages-hub/utils/create-limited-blurb';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';

type ArticleTileProps = {
  item: Article;
};

const ArticleTile = ({ item: article }: ArticleTileProps) => {
  const { identifier, imageObject, name, descriptionRaw, insuranceType } = article;
  const type = insuranceType?.identifier?.current;
  const descriptionPlainText = portableTextToPlain(descriptionRaw);
  const blurb = createLimitedBlurb(descriptionPlainText, TRIM_CHARACTER_LIMIT);
  const slug = identifier?.current;
  const url = `/${type}-insurance${constants.URLS.SALES.ARTICLES}/${slug}`;
  const imageAttributes = getImageAttributes({ imageObject, width: 400 });

  return (
    <ArticleTileWrapper>
      <div>
        {/* @ts-expect-error - imageAttributes may be null, handle appropriately */}
        <StyledImage {...imageAttributes} />
        <HeadingWrapper>
          <H3 variant="marginBottomSpacer10" looksLike="h4">
            {name}
          </H3>
        </HeadingWrapper>
        <ArticleMetadata isLeftAligned article={article} />
        <P variant="marginBottomSpacer10">{blurb}</P>
      </div>
      <Button to={url} variant={['white', 'wide', 'border']}>
        Read article
      </Button>
    </ArticleTileWrapper>
  );
};

export default ArticleTile;
